import Debug from 'debug'
const debug = Debug('app:shared:wage-calc')

/**
 * Calculates wage estimations.
 *
 * @param {Object} opts
 * @param {Object} opts.wcRate - The workers comp object that maps job type to wc.
 * @param {string} opts.pricing - The pricing model the company is on.
 * @param {number} opts.wage - The per hour wage for the job.
 * @param {number} opts.workers - The number of workers for the job.
 * @param {date} opts.startTime - The start time of the shift.
 * @param {date} opts.endTime - The end time of the shift.
 * @param {string} opts.startDate - The start date of the job.
 * @param {date} opts.endDate - The end date of the job.
 * @param {number} [opts.markup] - The markup rate for companies on markup pricing, or service fee if daily.
 * @param {boolean} [opts.shifts] - If job is over a week long, do they want workers on the weekend?
 */
const calculate = (opts) => {
  debug('calculate args %o', opts)
  let adminFee = 0.02
  let taxes = 0.1595
  let workersComp = 0.12
  let lunches = 0
  let totalHours
  let shiftLength
  let totalCost
  let serviceFee // Service fee, i.e. $20/day or markup percentage.
  let calculation = {}
  let perWeek = false
  const wages = opts.wage

  if (opts.wcRate) {
    workersComp = opts.wcRate / 100
  } else if (opts.WC[opts.jobType]) {
    workersComp = parseFloat(opts.WC[opts.jobType]) / 100
  } else if (Object.keys(opts.WC).length > 0) {
    workersComp = parseFloat(opts.WC[Object.keys(opts.WC)[0]]) / 100
  }
  const costs = adminFee + taxes + workersComp

  // If pricing isn't markup, default to daily.
  const pricing = opts.pricing === opts.pricing || 'daily'

  shiftLength = opts.shiftLength

  if (shiftLength > 10) perWeek = false
  totalHours = opts.numShifts * shiftLength * opts.workers

  // Subtracts a 30 minute lunch break if job is over 5 hours
  if (shiftLength >= 5) {
    lunches = 0.5 * opts.numShifts * opts.workers
  }

  const totalSalary = (totalHours - lunches) * wages

  if (opts.pricing === 'markup') {
    totalCost = totalSalary * opts.markup
    serviceFee = (opts.markup - 1) * 100
    calculation = {
      subTotal: totalSalary.toFixed(2), // sub-total.
      serviceFee: serviceFee.toFixed(2), // markup %
      totalCost: totalCost.toFixed(2) // $total
    }
  } else if (opts.pricing === 'daily') {
    serviceFee = opts.markup * opts.numShifts * opts.workers
    let taxesAndComp = totalSalary * costs
    totalCost = totalSalary * (1 + costs) + serviceFee
    calculation = {
      subTotal: totalSalary.toFixed(2), // wages.
      serviceFee: serviceFee.toFixed(2), // service fee.
      taxesAndComp: taxesAndComp.toFixed(2), // est taxes and wc.
      totalCost: totalCost.toFixed(2), // $total
      perWeek: perWeek
    }
  } else if (opts.pricing === 'bill_rate') {
    totalCost = (totalHours - lunches) * opts.markup
    calculation = {
      totalCost: totalCost.toFixed(2) // $total
    }
  }
  calculation.totalHours = totalHours
  calculation.numShifts = opts.numShifts
  calculation.shiftLength = shiftLength

  return calculation
}

export default calculate
